import { StatusBar } from "expo-status-bar";
import { useCallback, useEffect, useState } from "react";
import { StyleSheet, Text, View, I18nManager, Platform } from "react-native";
import Main from "./Main";
import { Provider } from "react-redux";
import store from "./redux/store";
import { NavigationContainer, DefaultTheme } from "@react-navigation/native";
import { getLocales, getCalendars } from "expo-localization";
import axios from "axios";
import getLanguage, { setI18nConfig, setLanguage } from "./functions/Language";
import { useFonts } from "expo-font";
import Cookies from "universal-cookie";
import Splash from "./Splash";
import getToken from "./api/token";
import Toast from "react-native-toast-message";
import * as SplashScreen from "expo-splash-screen";
import * as Updates from "expo-updates";
import { height } from "./imports";
import MyText from "./components/custom/MyText";
import { success, white } from "./colors";
const cookies = new Cookies();
I18nManager.forceRTL(true);
I18nManager.allowRTL(true);

const toastConfig = {
  /*
    Overwrite 'success' type,
    by modifying the existing `BaseToast` component
  */
  success: ({ text1 }) => (
    <View
      style={{
        width: "90%",
        backgroundColor: "white",
        borderRadius: 10,
        padding: 5,
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <MyText
        style={{
          color: success,
          textAlign: "center",
          width: "100%",
        }}
      >
        {text1}
      </MyText>
    </View>
  ),
  /*
    Overwrite 'error' type,
    by modifying the existing `ErrorToast` component
  */

  /*
    Or create a completely new type - `tomatoToast`,
    building the layout from scratch.

    I can consume any custom `props` I want.
    They will be passed when calling the `show` method (see below)
  */
  error: ({ text1 }) => (
    <View
      style={{
        width: "90%",
        backgroundColor: "tomato",
        borderRadius: 10,
        padding: 5,
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <MyText
        style={{
          color: white,
          textAlign: "center",
          width: "100%",
        }}
      >
        {text1}
      </MyText>
    </View>
  ),
};

export default function App() {

  const [wait, setWait] = useState(true);
  const [splashDone, setSplashDone] = useState(false);
  if (Platform.OS !== "web") {
    if (!I18nManager.isRTL) {
      Updates.reloadAsync();
    }
  }
  useEffect(() => {
    setLanguage("persian");
    getLanguage();
  }, []);

  let [fontsLoaded] = useFonts({
    main: require("./assets/fonts/Vazir.ttf"),
    virgoul: require("./assets/fonts/Vazir.ttf"),
  });

  const onLayoutRootView = useCallback(async () => {
    if (fontsLoaded) {
      await SplashScreen.hideAsync();
    }
  }, [fontsLoaded]);

  useEffect(() => {
    let rtl = true;
    let lang = "persian";
    if (Platform.OS === "web") {
      rtl = true;
      lang = "persian";
      store.dispatch({ type: "SET_RTL", rtl: rtl, language: lang });
      getToken();
      setWait(false);
    } else {
      rtl = true;
      lang = "persian";
      store.dispatch({ type: "SET_RTL", rtl: rtl, language: lang });
      getToken();
      setWait(false);
    }
  }, []);

  if (!fontsLoaded) {
    return null;
  }

  return (
    <Provider store={store}>
      <NavigationContainer
        theme={{
          ...DefaultTheme,
          colors: {
            ...DefaultTheme.colors,
            background: "#fff",
          },
        }}
      >
        <Main />

        <Toast config={toastConfig} />
      </NavigationContainer>
    </Provider>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#fff",
    alignItems: "center",
    justifyContent: "center",
  },
});
